<template>
  <!-- 电话选择 -->
  <div class="tel-input" :class="{error: hasError}">
    <div class="area-code">
      <select :value="areaCode" @change="$emit('updateCode', $event.target.value)">
        <option v-for="(val, index) in areaCodeList" :key="index" :value="val">
          +{{ val }}
        </option>
      </select>
      <div class="arrow">
        <KkIcon name="ic_triangleDown_line" size="xs" class="arrow-down" />
      </div>
    </div>
    <input :value="value" @input="$emit('input', $event.target.value)" />
  </div>
</template>

<script>
import { KkIcon } from '@kkday/web-design-system'

export default {
  props: {
    value: {
      type: String
    },
    areaCode: {
      type: String
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  components: {
    KkIcon
  },
  computed: {
    areaCodeList() {
      return this.$store.state.common.areaCodeList
    }
  },
  data() {
    return {
      code: this.areaCode || '+1',
      visiable: false
    }
  },
  created() {
    this.$store.dispatch('getIsoCountries')
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.tel-input {
  border-radius: var(--kk-radius-md);
  border: 1px solid var(--kk-color-border-light);
  background: #FFF;
  padding: 14px var(--kk-spacing-4);
  box-sizing: border-box;
  display: flex;
  position: relative;
  .area-code {
    display: flex;
    align-items: center;
    position: relative;
    min-width: 72px;
    select {
      border: none;
      outline: none;
      appearance: none;
      margin-left: var(--kk-spacing-2);
      min-width: 60px;
      margin-right: var(--kk-spacing-3);
      z-index: 1;
      background: #0000;
    }
    .arrow {
      width: 38px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: var(--kk-spacing-3);
      margin-right: var(--kk-spacing-2);
      position: absolute;
      right: 0px;
    }
    .arrow-down {
      color: #727272;
    }
  }
  input {
    border: none;
    outline: none;
    width: 100%;
  }
}
.error {
  border-color: var(--kk-color-text-critical-dark);
}
</style>
